import axios from "axios";
import { API_BASE_URL } from "../config/apiConfig";

export const createEvento = async (formData) => {
  const token = localStorage.getItem("authToken");
  const headers = {
    Authorization: `${token}`,
  };
  const response = await axios.post(`${API_BASE_URL}/agendas`, formData, { headers });
  return response.data;
};

export const getEventos = async () => {
  const token = localStorage.getItem("authToken"); // Autenticación
  const headers = {
    Authorization: `${token}`,
  };
  const response = await axios.get(`${API_BASE_URL}/agendas`, { headers });
  return response.data; // Retorna los datos del backend
};

export const getEventosPorFecha = async (fecha) => {
  const token = localStorage.getItem("authToken"); // Autenticación
  const headers = {
    Authorization: `${token}`,
  };
  const response = await axios.get(`${API_BASE_URL}/agendas/fecha/${fecha}`, { headers });
  return response.data;
};

// Obtener evento por ID
export const getEventosPorID = async (id) => {
  const token = localStorage.getItem("authToken");
  const headers = {
    Authorization: `${token}`,
  };
  const response = await axios.get(`${API_BASE_URL}/agendas/id/${id}`, {
    headers,
  });
  return response.data;
};

// Actualizar un evento
export const updateEvento = async (id, formData) => {
  const token = localStorage.getItem("authToken");
  const headers = {
    Authorization: `${token}`
  };
  const response = await axios.put(`${API_BASE_URL}/agendas/${id}`, formData, {
    headers,
  });
  return response.data;
};

// Eliminar un evento
export const deleteEvento = async (id) => {
  const token = localStorage.getItem("authToken");
  const headers = {
    Authorization: `${token}`,
  };
  const response = await axios.delete(`${API_BASE_URL}/agendas/${id}`, {
    headers,
  });
  return response.data;
};